import { useMemo } from 'react';
import type { AssetShareModel } from '../../promote/viewer/useAssetShare';
import { useWatermarkChoice } from './useWatermarkChoice';
import type { WatermarkDownloadFile } from './WatermarkDownloadLink';

/**
 * The share model of the asset viewer with the choice (design: trial-upsell a2) in front of "Share
 * link" and "Copy": on Free and the trial a watermarked file asks on each click, and "Share with
 * the watermark" then makes or copies the link with one click. Every other action is unchanged.
 */
export function useGatedAssetShare(
  share: AssetShareModel,
  hasWatermark: boolean,
  file: WatermarkDownloadFile
): AssetShareModel {
  const { gate } = useWatermarkChoice();
  return useMemo(
    () => ({
      ...share,
      create: () => {
        gate(hasWatermark, { ...file, surface: 'share', onContinue: share.create });
      },
      copy: () => {
        gate(hasWatermark, { ...file, surface: 'share', onContinue: share.copy });
      },
    }),
    [file, gate, hasWatermark, share]
  );
}
